import * as React from "react";

import {
  GridCellParams,
  GridValueFormatterParams,
} from "@material-ui/data-grid";
import Avatar from "@material-ui/core/Avatar";
import Chip from "@material-ui/core/Chip";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { ReleaseIndexSchema } from "../../../../../../services/search-admin/types/index-schema/release-index-schema";
import moment from "moment";
import Flag from "../../../components/flag";
import "./style.css";

const getRevenue = (release: ReleaseIndexSchema) => {
  if (release.paidItems?.length) {
    return (
      release.paidItems.reduce(
        (memo, i) => memo + i.price.value * i.quantity,
        0
      ) / 100
    );
  }
};

const getCircleColor = (choice: string) => {
  let color = "";
  switch (choice) {
    case "W":
      color = "#f50057";
      break;
    case "B":
      color = "#efd07d";
      break;
    case "P":
      color = "#ffa500";
      break;
    case "I":
      color = "#f44336";
      break;
    default:
      color = "";
      break;
  }
  return color;
};

export const RELEASE_LIST_COLUMNS = [
  {
    field: "title",
    headerName: "Title",
    width: 300,
    renderCell: (params: GridCellParams) => (
      <Box style={{ display: "flex", alignItems: "center" }}>
        <Avatar
          alt={`${params.value} Cover`}
          src={params.row.cover?.url}
          style={{ marginRight: "1em" }}
        />
        <Typography>{params.value}</Typography>
      </Box>
    ),
  },
  {
    field: "artist",
    headerName: "Artist",
    width: 200,
    renderCell: (params: GridValueFormatterParams) => {
      const release = params.row as ReleaseIndexSchema;
      let enabled = false;
      if (
        release?.artist?.enabled === undefined ||
        release?.artist?.enabled === true
      ) {
        enabled = true;
      }
      return enabled ? (
        <Typography>{release?.artist?.name}</Typography>
      ) : (
        <Typography>
          {" "}
          <b style={{ color: "red" }}>*</b> {release?.artist?.name}
        </Typography>
      );
    },
  },
  {
    field: "UPCEAN",
    headerName: "UPCEAN",
    type: "number",
    width: 140,
    renderCell: (params: GridCellParams) => (
      <Typography>{params.value || "-"}</Typography>
    ),
  },
  {
    field: "Version",
    headerName: "Version",
    type: "number",
    width: 140,
    valueFormatter: (params: GridValueFormatterParams) => {
      const release = params.row as ReleaseIndexSchema;
      return release.version || "-";
    },
  },
  {
    field: "releaseDate",
    headerName: "Date",
    width: 140,
    type: "date",
    valueFormatter: (params: GridValueFormatterParams) => {
      const release = params.row as ReleaseIndexSchema;

      const releaseDate = moment(
        release.preorderDate || release.releaseDate || "?"
      );
      return releaseDate.isValid() ? releaseDate.format("ddd MMM D YYYY") : "?";
    },
  },
  {
    field: "updated_at",
    headerName: "Last Update",
    width: 140,
    type: "date",
    valueFormatter: (params: GridValueFormatterParams) => {
      const release = params.row as ReleaseIndexSchema;

      const updatedAt = moment(release.updated_at);
      return updatedAt.isValid() ? updatedAt.format("ddd MMM D YYYY") : "?";
    },
  },
  {
    field: "revenue",
    headerName: "Revenue",
    type: "number",
    width: 140,
    valueFormatter: (params: GridValueFormatterParams) => {
      const revenue = getRevenue(params.row as ReleaseIndexSchema);
      return revenue ? `$${revenue.toFixed(2)}` : undefined;
    },
  },
  {
    field: "ACRScore",
    headerName: "ACR Score",
    width: 140,
    renderCell: (params: GridCellParams) => {
      const release = params.row as ReleaseIndexSchema;

      const ACRScore = release.ACRScore
        ? release.ACRScore > 1
          ? 1
          : release.ACRScore
        : 0 || 0;

      return (
        <Chip
          size="small"
          label={`${(ACRScore * 100).toFixed(0)}%`}
          variant={ACRScore > 90 ? "default" : "outlined"}
          color={ACRScore > 0 ? "secondary" : "default"}
        />
      );
    },
  },
  {
    field: "inWatchlist",
    headerName: "Watchlist",
    width: 140,
    renderCell: (params: GridCellParams) => {
      return (
        <>
          {params.row?.artist?.inWatchlist && (
            <div
              title="In Watch List"
              className="dot center"
              style={{ backgroundColor: getCircleColor("W") }}
            >
              <span className="center">W</span>
            </div>
          )}
          {params.row?.artist?.enabled === false && (
            <div
              title="Blocked Artist"
              className="dot center"
              style={{ backgroundColor: getCircleColor("B") }}
            >
              <span className="center">B</span>
            </div>
          )}
          {params.row?.artist?.inBlocklist?.includes("P") && (
            <div
              className="dot center"
              style={{ backgroundColor: getCircleColor("P") }}
            >
              <span className="center">P</span>
            </div>
          )}
          {params.row?.artist?.inBlocklist?.includes("I") && (
            <div
              className="dot center"
              style={{ backgroundColor: getCircleColor("I") }}
            >
              <span className="center">I</span>
            </div>
          )}
        </>
      );
    },
  },
  {
    field: "artistPlan",
    headerName: "Plan",
    width: 160,
    renderCell: (params: GridCellParams) => {
      const release = params.row as ReleaseIndexSchema;
      let plan = release.artist?.subscription?.plan || "Beginner";
      if (!release.artist?.subscription?.isActive) {
        plan = `${plan} (INACTIVE)`;
      }

      return plan ? (
        <Chip
          size="small"
          label={plan}
          color={plan.includes("Pro") ? "primary" : "default"}
        />
      ) : (
        <></>
      );
    },
  },
  {
    field: "backofficeSubmit",
    headerName: "Submited",
    width: 200,
    type: "date",
    valueFormatter: (params: GridValueFormatterParams) => {
      const submittedDate = moment(params.value as number, "x");
      return submittedDate.isValid()
        ? submittedDate.format("ddd MMM D YYYY")
        : "?";
    },
    // params.value ? new Date(params.value as number).toDateString() : "?",
  },
  // // {
  // //   field: "priority",
  // //   headerName: "Priority",
  // //   width: 140
  // // },
  {
    field: "requestCounter",
    headerName: "Request #",
    type: "number",
    width: 150,
    renderCell: (params: GridCellParams) =>
      (params.value as number) >= 3 ? (
        <Chip size="small" label={params.value} color="secondary" />
      ) : (
        <Typography>{params.value}</Typography>
      ),
  },
  {
    field: "backofficeStatus",
    headerName: "Last Action",
    width: 150,
    renderCell: (params: GridCellParams) =>
      (params.value as string) === "rejected" ? (
        <Chip size="small" label={params.value} color="secondary" />
      ) : (
        <Typography>{params.value || "-"}</Typography>
      ),
  },
  {
    field: "country",
    headerName: "Country Flag",
    width: 200,
    renderCell: (params: GridValueFormatterParams) => {
      const release = params.row as ReleaseIndexSchema;

      return (
        <>
          <Flag
            className="dropdown-item-flag"
            bigFlag
            countryCode={release?.artist?.country?.id || "zz"}
            countryName={release?.artist?.country?.name || "-"}
          />
        </>
      );
    },
  },
];
